<template>


  <v-sheet max-height="640" class="overflow-auto">
    <v-list>
      <v-list-item-group>
        <template v-for="(order, index) in cashier.orders">
          <v-list-item :key="order.id" @click="emit(order.id)">
            <v-list-item-avatar size="56">
              <v-icon v-if="order.invoice" large color="primary">mdi-text-box-check</v-icon>
              <v-icon v-if="!order.invoice" large color="primary">mdi-file-document-alert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-truncate">
                #{{ order.id }} - {{ order.customer.name || 'Cliente não informado' }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-truncate">
                {{ order.time }}<br>
                Total: {{ order.total | currency }} &bull; Itens: {{ order.items.length }}
              </v-list-item-subtitle>
              <div class="mt-1">
                <v-chip small v-for="(payment, i) in order.payments" :key="i" class="ma-1" color="primary"
                  text-color="white">
                  {{ payment.payment_method.name }} {{ payment.amount | currency }}
                </v-chip>
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index < cashier.orders.length - 1" :key="'divider-' + order.id"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-sheet>



</template>

<script>
  import { mapActions, mapState } from "vuex";
  export default {
    methods: {
      ...mapActions("cashier", ["activeCashier"]),


      emit(id) {
        axios.get(`/api/orders/nfce/${id}`)
          .then(response => {
            this.$toast.success('Emissão da NFC-e enviada com sucesso!');
          })
          .catch(error => {
            const message = error.response?.data?.mensagem || 'Erro desconhecido ao emitir NFC-e.';
            this.$toast.error(message);
          });
        this.$emit('close-dialog');
      },
    },
    computed: {
      ...mapState("cashier", ["cashier"]),
      ...mapState("pos", ["pdv_id"]),
    },
    created() {
      this.activeCashier(this.pdv_id);
    },
  };
</script>
